import { apiService } from '@/api/apiConfig';

const handleError = (error: any): Error => {
  if (error.response?.data?.message) {
    return new Error(`Expense category operation failed: ${error.response.data.message}`);
  }
  return error instanceof Error ? error : new Error('Expense category operation failed');
};

export const adminPanelService = {
  getSubscribers: async (data: any) => {
    try {
      return await apiService.request<any>({
        method: 'GET',
        url: `/admin/subscribers`,
        params: data
      });
    } catch (error) {
      throw handleError(error);
    }
  },
  getYearlyStats: async (year: number) => {
    try {
      return await apiService.request<any>({
        method: 'GET',
        url: `/admin/subscribers/yearly-stats`,
        params: {
          year: year
        }
      });
    } catch (error) {
      throw handleError(error);
    }
  },
  getTotalSubscribersStats: async () => {
    try {
      return await apiService.request<any>({
        method: 'GET',
        url: `/admin/subscribers/stats`
      });
    } catch (error) {
      throw handleError(error);
    }
  },
  getNewSubscribersStats: async () => {
    try {
      return await apiService.request<any>({
        method: 'GET',
        url: `/admin/new-subscribers/stats`
      });
    } catch (error) {
      throw handleError(error);
    }
  },
  getRecentSubscribers: async (data: any) => {
    try {
      return await apiService.request<any>({
        method: 'GET',
        url: `/admin/recent-subscribers`,
        params: data
      });
    } catch (error) {
      throw handleError(error);
    }
  },
  banUser: async (id: string, data: any) => {
    try {
      return await apiService.request<any>({
        method: 'PATCH',
        url: `/admin/subscribers/${id}/ban`,
        data
      });
    } catch (error) {
      throw handleError(error);
    }
  },
  unbanUser: async (id: string) => {
    try {
      return await apiService.request<any>({
        method: 'PATCH',
        url: `/admin/subscribers/${id}/unban`
      });
    } catch (error) {
      throw handleError(error);
    }
  },
  reactivateUserById: async (id: string) => {
    try {
      return await apiService.request<any>({
        method: 'PATCH',
        url: `/admin/subscribers/${id}/reactivate`
      });
    } catch (error) {
      throw handleError(error);
    }
  }
};
